export const URL = process.env.REACT_APP_API_URL;
export const URL_THEME_PICTURES = process.env.REACT_APP_API_URL_THEME;
export const MENU_ADS_URL = process.env.REACT_APP_AD_URL;
export const STORE_URL = process.env.REACT_APP_STORE_URL;
export const WS_URL = process.env.REACT_APP_WS_URL;
